import { connect } from 'react-redux';
import {
  fetchResourceQuarantineFiles,
  fetchResourceQuarantineSamples,
  clearPaginatedResource,
} from '../../../actions';
import QuarantineDataTab from './QuarantineDataTab';
import {
  QUARANTINE_FILES_PAGINATED,
  QUARANTINE_SAMPLES_PAGINATED,
} from '../../../constants/paginationEntitiesTypes';

import has from 'lodash/has';
import {
  GET_RESOURCE_QUARANTINE_FILES_REQUEST,
  GET_RESOURCE_QUARANTINE_SAMPLES_REQUEST,
} from 'js/constants/actionTypes';

const mapStateToProps = (state, ownProps) => {
  const {
    data: { id },
    resourceType,
  } = ownProps;
  const {
    request,
    entities: { credentials },
    pagination: { data },
  } = state;
  const isLoadingErrorFiles = request[GET_RESOURCE_QUARANTINE_FILES_REQUEST];
  const isLoadingErrorSamples = request[GET_RESOURCE_QUARANTINE_SAMPLES_REQUEST];
  let quarantineResourceId = id;
  let quarantineResourceType = resourceType;
  let files = {};
  let samples = {};

  if (
    quarantineResourceId &&
    has(data, [QUARANTINE_FILES_PAGINATED, quarantineResourceType, quarantineResourceId, 'metrics'])
  ) {
    files = data[QUARANTINE_FILES_PAGINATED][quarantineResourceType][quarantineResourceId].metrics;
  }

  if (
    quarantineResourceId &&
    has(data, [
      QUARANTINE_SAMPLES_PAGINATED,
      quarantineResourceType,
      quarantineResourceId,
      'output',
    ])
  ) {
    samples =
      data[QUARANTINE_SAMPLES_PAGINATED][quarantineResourceType][quarantineResourceId].output;
  }

  return {
    isLoadingErrorFiles,
    isLoadingErrorSamples,
    files,
    credentials,
    samples,
  };
};

export default connect(mapStateToProps, {
  fetchResourceQuarantineFiles,
  clearPaginatedResource,
  fetchResourceQuarantineSamples,
})(QuarantineDataTab);
